import CheckIcon from '@heroicons/react/outline/esm/CheckIcon.js'
import XIcon from '@heroicons/react/outline/esm/XIcon.js'

export const BooleanView = ({ value }: { value: boolean }) => {
  if (value === true) {
    return <CheckIcon className="w-4 h-4 text-content-on-positive" />
  }
  return <XIcon className="w-4 h-4 text-action-destructive" />
}
